<template>
  <svg fill="none" viewBox="0 0 125 125">
    <g clip-path="url(#common-qr-a)" fill="#000">
      <path d="M3.288 0H-.5v3.788h3.788V0Z" />
      <path d="M7.076 0H3.288v3.788h3.788V0Z" />
      <path d="M10.864 0H7.076v3.788h3.788V0Z" />
      <path d="M14.652 0h-3.788v3.788h3.787V0Z" />
      <path d="M18.44 0H14.65v3.788h3.788V0Z" />
      <path d="M22.227 0H18.44v3.788h3.788V0Z" />
      <path d="M26.015 0h-3.788v3.788h3.788V0Z" />
      <path d="M44.955 0h-3.788v3.788h3.788V0Z" />
      <path d="M56.318 0H52.53v3.788h3.788V0Z" />
      <path d="M79.045 0h-3.787v3.788h3.787V0Z" />
      <path d="M82.833 0h-3.788v3.788h3.788V0Z" />
      <path d="M86.621 0h-3.788v3.788h3.788V0Z" />
      <path d="M90.41 0H86.62v3.788h3.788V0Z" />
      <path d="M94.197 0h-3.788v3.788h3.788V0Z" />
      <path d="M101.773 0h-3.788v3.788h3.788V0Z" />
      <path d="M105.561 0h-3.788v3.788h3.788V0Z" />
      <path d="M109.348 0h-3.787v3.788h3.787V0Z" />
      <path d="M113.136 0h-3.788v3.788h3.788V0Z" />
      <path d="M116.924 0h-3.788v3.788h3.788V0Z" />
      <path d="M120.712 0h-3.788v3.788h3.788V0Z" />
      <path d="M124.5 0h-3.788v3.788h3.788V0Z" />
      <path d="M3.288 3.788H-.5v3.788h3.788V3.788Z" />
      <path d="M26.015 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M33.59 3.788h-3.787v3.788h3.788V3.788Z" />
      <path d="M37.379 3.788H33.59v3.788h3.788V3.788Z" />
      <path d="M41.167 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M48.742 3.788h-3.787v3.788h3.787V3.788Z" />
      <path d="M52.53 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M56.318 3.788H52.53v3.788h3.788V3.788Z" />
      <path d="M75.258 3.788H71.47v3.788h3.788V3.788Z" />
      <path d="M79.045 3.788h-3.787v3.788h3.787V3.788Z" />
      <path d="M94.197 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M101.773 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M124.5 3.788h-3.788v3.788h3.788V3.788Z" />
      <path d="M3.288 7.576H-.5v3.788h3.788V7.576Z" />
      <path d="M10.864 7.576H7.076v3.788h3.788V7.576Z" />
      <path d="M14.652 7.576h-3.788v3.788h3.787V7.576Z" />
      <path d="M18.44 7.576H14.65v3.788h3.788V7.576Z" />
      <path d="M26.015 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M37.379 7.576H33.59v3.788h3.788V7.576Z" />
      <path d="M41.167 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M44.955 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M60.106 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M71.47 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M75.258 7.576H71.47v3.788h3.788V7.576Z" />
      <path d="M79.045 7.576h-3.787v3.788h3.787V7.576Z" />
      <path d="M94.197 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M101.773 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M109.348 7.576h-3.787v3.788h3.787V7.576Z" />
      <path d="M113.136 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M116.924 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M124.5 7.576h-3.788v3.788h3.788V7.576Z" />
      <path d="M3.288 11.364H-.5v3.787h3.788v-3.787Z" />
      <path d="M10.864 11.364H7.076v3.787h3.788v-3.787Z" />
      <path d="M14.652 11.364h-3.788v3.787h3.787v-3.787Z" />
      <path d="M18.44 11.364H14.65v3.787h3.788v-3.787Z" />
      <path d="M26.015 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M37.379 11.364H33.59v3.787h3.788v-3.787Z" />
      <path d="M48.742 11.364h-3.787v3.787h3.787v-3.787Z" />
      <path d="M52.53 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M60.106 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M67.682 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M71.47 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M75.258 11.364H71.47v3.787h3.788v-3.787Z" />
      <path d="M82.833 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M86.621 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M101.773 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M109.348 11.364h-3.787v3.787h3.787v-3.787Z" />
      <path d="M113.136 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M116.924 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M124.5 11.364h-3.788v3.787h3.788v-3.787Z" />
      <path d="M3.288 15.152H-.5v3.787h3.788v-3.787Z" />
      <path d="M10.864 15.152H7.076v3.787h3.788v-3.787Z" />
      <path d="M14.652 15.152h-3.788v3.787h3.787v-3.787Z" />
      <path d="M18.44 15.152H14.65v3.787h3.788v-3.787Z" />
      <path d="M26.015 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M41.167 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M44.955 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M52.53 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M56.318 15.152H52.53v3.787h3.788v-3.787Z" />
      <path d="M63.894 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M75.258 15.152H71.47v3.787h3.788v-3.787Z" />
      <path d="M79.045 15.152h-3.787v3.787h3.787v-3.787Z" />
      <path d="M82.833 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M90.41 15.152H86.62v3.787h3.788v-3.787Z" />
      <path d="M94.197 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M101.773 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M109.348 15.152h-3.787v3.787h3.787v-3.787Z" />
      <path d="M113.136 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M116.924 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M124.5 15.152h-3.788v3.787h3.788v-3.787Z" />
      <path d="M3.288 18.94H-.5v3.787h3.788V18.94Z" />
      <path d="M26.015 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M37.379 18.94H33.59v3.787h3.788V18.94Z" />
      <path d="M41.167 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M48.742 18.94h-3.787v3.787h3.787V18.94Z" />
      <path d="M56.318 18.94H52.53v3.787h3.788V18.94Z" />
      <path d="M60.106 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M67.682 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M71.47 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M82.833 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M101.773 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M124.5 18.94h-3.788v3.787h3.788V18.94Z" />
      <path d="M3.288 22.727H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 22.727H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 22.727H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 22.727h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 22.727H14.65v3.788h3.788v-3.788Z" />
      <path d="M22.227 22.727H18.44v3.788h3.788v-3.788Z" />
      <path d="M26.015 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 22.727h-3.787v3.788h3.788v-3.788Z" />
      <path d="M41.167 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 22.727h-3.787v3.788h3.787v-3.788Z" />
      <path d="M56.318 22.727H52.53v3.788h3.788v-3.788Z" />
      <path d="M63.894 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 22.727h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M94.197 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 22.727h-3.787v3.788h3.787v-3.788Z" />
      <path d="M113.136 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 22.727h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 26.515h-3.787v3.788h3.788v-3.788Z" />
      <path d="M60.106 26.515h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 26.515h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 26.515h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 26.515H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 26.515h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 26.515h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 26.515H86.62v3.788h3.788v-3.788Z" />
      <path d="M3.288 30.303H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 30.303H3.288v3.788h3.788v-3.788Z" />
      <path d="M26.015 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 30.303h-3.787v3.788h3.788v-3.788Z" />
      <path d="M41.167 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 30.303h-3.787v3.788h3.787v-3.788Z" />
      <path d="M52.53 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 30.303H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 30.303H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 30.303h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M86.621 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M94.197 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M97.985 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 30.303h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 34.09H-.5v3.789h3.788V34.09Z" />
      <path d="M7.076 34.09H3.288v3.789h3.788V34.09Z" />
      <path d="M10.864 34.09H7.076v3.789h3.788V34.09Z" />
      <path d="M14.652 34.09h-3.788v3.789h3.787V34.09Z" />
      <path d="M22.227 34.09H18.44v3.789h3.788V34.09Z" />
      <path d="M29.803 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M33.59 34.09h-3.787v3.789h3.788V34.09Z" />
      <path d="M37.379 34.09H33.59v3.789h3.788V34.09Z" />
      <path d="M44.955 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M48.742 34.09h-3.787v3.789h3.787V34.09Z" />
      <path d="M56.318 34.09H52.53v3.789h3.788V34.09Z" />
      <path d="M60.106 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M67.682 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M71.47 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M75.258 34.09H71.47v3.789h3.788V34.09Z" />
      <path d="M86.621 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M94.197 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M109.348 34.09h-3.787v3.789h3.787V34.09Z" />
      <path d="M116.924 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M124.5 34.09h-3.788v3.789h3.788V34.09Z" />
      <path d="M3.288 37.879H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 37.879H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 37.879H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 37.879h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 37.879H14.65v3.788h3.788v-3.788Z" />
      <path d="M22.227 37.879H18.44v3.788h3.788v-3.788Z" />
      <path d="M26.015 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M29.803 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 37.879h-3.787v3.788h3.788v-3.788Z" />
      <path d="M41.167 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 37.879H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 37.879H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 37.879h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 37.879H86.62v3.788h3.788v-3.788Z" />
      <path d="M101.773 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 37.879h-3.788v3.788h3.788v-3.788Z" />
      <path d="M7.076 41.667H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 41.667H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 41.667h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 41.667H14.65v3.788h3.788v-3.788Z" />
      <path d="M22.227 41.667H18.44v3.788h3.788v-3.788Z" />
      <path d="M44.955 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M52.53 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 41.667H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 41.667h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M97.985 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 41.667h-3.787v3.788h3.787v-3.788Z" />
      <path d="M120.712 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 41.667h-3.788v3.788h3.788v-3.788Z" />
      <path d="M10.864 45.455H7.076v3.787h3.788v-3.787Z" />
      <path d="M14.652 45.455h-3.788v3.787h3.787v-3.787Z" />
      <path d="M26.015 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M29.803 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M33.59 45.455h-3.787v3.787h3.788v-3.787Z" />
      <path d="M44.955 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M48.742 45.455h-3.787v3.787h3.787v-3.787Z" />
      <path d="M63.894 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M67.682 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M90.41 45.455H86.62v3.787h3.788v-3.787Z" />
      <path d="M97.985 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M101.773 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M105.561 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M113.136 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M120.712 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M124.5 45.455h-3.788v3.787h3.788v-3.787Z" />
      <path d="M3.288 49.242H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 49.242H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 49.242H7.076v3.788h3.788v-3.788Z" />
      <path d="M18.44 49.242H14.65v3.788h3.788v-3.788Z" />
      <path d="M29.803 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 49.242h-3.787v3.788h3.788v-3.788Z" />
      <path d="M37.379 49.242H33.59v3.788h3.788v-3.788Z" />
      <path d="M41.167 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 49.242h-3.787v3.788h3.787v-3.788Z" />
      <path d="M52.53 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 49.242H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 49.242h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M86.621 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 49.242h-3.787v3.788h3.787v-3.788Z" />
      <path d="M116.924 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 49.242h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 53.03H-.5v3.788h3.788V53.03Z" />
      <path d="M26.015 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M29.803 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M33.59 53.03h-3.787v3.788h3.788V53.03Z" />
      <path d="M41.167 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M56.318 53.03H52.53v3.788h3.788V53.03Z" />
      <path d="M60.106 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M79.045 53.03h-3.787v3.788h3.787V53.03Z" />
      <path d="M86.621 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M97.985 53.03h-3.788v3.788h3.788V53.03Z" />
      <path d="M3.288 56.818H-.5v3.788h3.788v-3.788Z" />
      <path d="M14.652 56.818h-3.788v3.788h3.787v-3.788Z" />
      <path d="M22.227 56.818H18.44v3.788h3.788v-3.788Z" />
      <path d="M37.379 56.818H33.59v3.788h3.788v-3.788Z" />
      <path d="M52.53 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 56.818H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 56.818H71.47v3.788h3.788v-3.788Z" />
      <path d="M90.41 56.818H86.62v3.788h3.788v-3.788Z" />
      <path d="M94.197 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M97.985 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 56.818h-3.788v3.788h3.788v-3.788Z" />
      <path d="M7.076 60.606H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 60.606H7.076v3.788h3.788v-3.788Z" />
      <path d="M18.44 60.606H14.65v3.788h3.788v-3.788Z" />
      <path d="M22.227 60.606H18.44v3.788h3.788v-3.788Z" />
      <path d="M26.015 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M29.803 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M37.379 60.606H33.59v3.788h3.788v-3.788Z" />
      <path d="M52.53 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M60.106 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 60.606H86.62v3.788h3.788v-3.788Z" />
      <path d="M94.197 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 60.606h-3.787v3.788h3.787v-3.788Z" />
      <path d="M113.136 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 60.606h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 64.394H-.5v3.788h3.788v-3.788Z" />
      <path d="M22.227 64.394H18.44v3.788h3.788v-3.788Z" />
      <path d="M33.59 64.394h-3.787v3.788h3.788v-3.788Z" />
      <path d="M37.379 64.394H33.59v3.788h3.788v-3.788Z" />
      <path d="M41.167 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 64.394h-3.787v3.788h3.787v-3.788Z" />
      <path d="M56.318 64.394H52.53v3.788h3.788v-3.788Z" />
      <path d="M71.47 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 64.394h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M86.621 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M97.985 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M113.136 64.394h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 68.182H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 68.182H3.288v3.788h3.788v-3.788Z" />
      <path d="M14.652 68.182h-3.788v3.788h3.787v-3.788Z" />
      <path d="M26.015 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M37.379 68.182H33.59v3.788h3.788v-3.788Z" />
      <path d="M44.955 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M52.53 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M60.106 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 68.182H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 68.182h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 68.182H86.62v3.788h3.788v-3.788Z" />
      <path d="M94.197 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M113.136 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 68.182h-3.788v3.788h3.788v-3.788Z" />
      <path d="M10.864 71.97H7.076v3.788h3.788V71.97Z" />
      <path d="M14.652 71.97h-3.788v3.788h3.787V71.97Z" />
      <path d="M22.227 71.97H18.44v3.788h3.788V71.97Z" />
      <path d="M29.803 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M33.59 71.97h-3.787v3.788h3.788V71.97Z" />
      <path d="M37.379 71.97H33.59v3.788h3.788V71.97Z" />
      <path d="M48.742 71.97h-3.787v3.788h3.787V71.97Z" />
      <path d="M67.682 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M71.47 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M75.258 71.97H71.47v3.788h3.788V71.97Z" />
      <path d="M86.621 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M90.41 71.97H86.62v3.788h3.788V71.97Z" />
      <path d="M97.985 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M105.561 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M109.348 71.97h-3.787v3.788h3.787V71.97Z" />
      <path d="M116.924 71.97h-3.788v3.788h3.788V71.97Z" />
      <path d="M7.076 75.758H3.288v3.787h3.788v-3.787Z" />
      <path d="M10.864 75.758H7.076v3.787h3.788v-3.787Z" />
      <path d="M14.652 75.758h-3.788v3.787h3.787v-3.787Z" />
      <path d="M18.44 75.758H14.65v3.787h3.788v-3.787Z" />
      <path d="M26.015 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M29.803 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M37.379 75.758H33.59v3.787h3.788v-3.787Z" />
      <path d="M41.167 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M44.955 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M56.318 75.758H52.53v3.787h3.788v-3.787Z" />
      <path d="M60.106 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M63.894 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M67.682 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M71.47 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M90.41 75.758H86.62v3.787h3.788v-3.787Z" />
      <path d="M97.985 75.758h-3.788v3.787h3.788v-3.787Z" />
      <path d="M109.348 75.758h-3.787v3.787h3.787v-3.787Z" />
      <path d="M3.288 79.545H-.5v3.788h3.788v-3.788Z" />
      <path d="M10.864 79.545H7.076v3.788h3.788v-3.788Z" />
      <path d="M18.44 79.545H14.65v3.788h3.788v-3.788Z" />
      <path d="M37.379 79.545H33.59v3.788h3.788v-3.788Z" />
      <path d="M44.955 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 79.545h-3.787v3.788h3.787v-3.788Z" />
      <path d="M56.318 79.545H52.53v3.788h3.788v-3.788Z" />
      <path d="M71.47 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 79.545h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M86.621 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M97.985 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 79.545h-3.787v3.788h3.787v-3.788Z" />
      <path d="M116.924 79.545h-3.788v3.788h3.788v-3.788Z" />
      <path d="M10.864 83.333H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 83.333h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 83.333H14.65v3.788h3.788v-3.788Z" />
      <path d="M26.015 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 83.333h-3.787v3.788h3.788v-3.788Z" />
      <path d="M41.167 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M60.106 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 83.333H71.47v3.788h3.788v-3.788Z" />
      <path d="M86.621 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 83.333h-3.787v3.788h3.787v-3.788Z" />
      <path d="M120.712 83.333h-3.788v3.788h3.788v-3.788Z" />
      <path d="M22.227 87.121H18.44v3.788h3.788v-3.788Z" />
      <path d="M29.803 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 87.121h-3.787v3.788h3.788v-3.788Z" />
      <path d="M37.379 87.121H33.59v3.788h3.788v-3.788Z" />
      <path d="M48.742 87.121h-3.787v3.788h3.787v-3.788Z" />
      <path d="M67.682 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 87.121h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 87.121H86.62v3.788h3.788v-3.788Z" />
      <path d="M101.773 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M113.136 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 87.121h-3.788v3.788h3.788v-3.788Z" />
      <path d="M10.864 90.91H7.076v3.787h3.788v-3.788Z" />
      <path d="M14.652 90.91h-3.788v3.787h3.787v-3.788Z" />
      <path d="M22.227 90.91H18.44v3.787h3.788v-3.788Z" />
      <path d="M26.015 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M33.59 90.91h-3.787v3.787h3.788v-3.788Z" />
      <path d="M41.167 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M52.53 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M60.106 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M63.894 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M71.47 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M79.045 90.91h-3.787v3.787h3.787v-3.788Z" />
      <path d="M86.621 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M94.197 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M97.985 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M101.773 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M105.561 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M109.348 90.91h-3.787v3.787h3.787v-3.788Z" />
      <path d="M120.712 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M124.5 90.91h-3.788v3.787h3.788v-3.788Z" />
      <path d="M33.59 94.697h-3.787v3.788h3.788v-3.788Z" />
      <path d="M41.167 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 94.697h-3.787v3.788h3.787v-3.788Z" />
      <path d="M56.318 94.697H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M79.045 94.697h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 94.697H86.62v3.788h3.788v-3.788Z" />
      <path d="M94.197 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 94.697h-3.787v3.788h3.787v-3.788Z" />
      <path d="M113.136 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 94.697h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 98.485H-.5v3.788h3.788v-3.788Z" />
      <path d="M7.076 98.485H3.288v3.788h3.788v-3.788Z" />
      <path d="M10.864 98.485H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 98.485h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 98.485H14.65v3.788h3.788v-3.788Z" />
      <path d="M22.227 98.485H18.44v3.788h3.788v-3.788Z" />
      <path d="M26.015 98.485h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 98.485h-3.787v3.788h3.787v-3.788Z" />
      <path d="M56.318 98.485H52.53v3.788h3.788v-3.788Z" />
      <path d="M67.682 98.485h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 98.485H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 98.485h-3.787v3.788h3.787v-3.788Z" />
      <path d="M82.833 98.485h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 98.485H86.62v3.788h3.788v-3.788Z" />
      <path d="M94.197 98.485h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 98.485h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 98.485h-3.787v3.788h3.787v-3.788Z" />
      <path d="M3.288 102.273H-.5v3.788h3.788v-3.788Z" />
      <path d="M26.015 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M48.742 102.273h-3.787v3.788h3.787v-3.788Z" />
      <path d="M52.53 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 102.273H52.53v3.788h3.788v-3.788Z" />
      <path d="M63.894 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M82.833 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M94.197 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 102.273h-3.787v3.788h3.787v-3.788Z" />
      <path d="M113.136 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 102.273h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 106.061H-.5v3.787h3.788v-3.787Z" />
      <path d="M10.864 106.061H7.076v3.787h3.788v-3.787Z" />
      <path d="M14.652 106.061h-3.788v3.787h3.787v-3.787Z" />
      <path d="M18.44 106.061H14.65v3.787h3.788v-3.787Z" />
      <path d="M26.015 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M37.379 106.061H33.59v3.787h3.788v-3.787Z" />
      <path d="M41.167 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M44.955 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M56.318 106.061H52.53v3.787h3.788v-3.787Z" />
      <path d="M63.894 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M75.258 106.061H71.47v3.787h3.788v-3.787Z" />
      <path d="M79.045 106.061h-3.787v3.787h3.787v-3.787Z" />
      <path d="M82.833 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M90.41 106.061H86.62v3.787h3.788v-3.787Z" />
      <path d="M94.197 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M97.985 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M101.773 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M105.561 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M109.348 106.061h-3.787v3.787h3.787v-3.787Z" />
      <path d="M113.136 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M116.924 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M120.712 106.061h-3.788v3.787h3.788v-3.787Z" />
      <path d="M3.288 109.848H-.5v3.788h3.788v-3.788Z" />
      <path d="M10.864 109.848H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 109.848h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 109.848H14.65v3.788h3.788v-3.788Z" />
      <path d="M26.015 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M37.379 109.848H33.59v3.788h3.788v-3.788Z" />
      <path d="M44.955 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M52.53 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 109.848H52.53v3.788h3.788v-3.788Z" />
      <path d="M60.106 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M63.894 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 109.848H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 109.848h-3.787v3.788h3.787v-3.788Z" />
      <path d="M90.41 109.848H86.62v3.788h3.788v-3.788Z" />
      <path d="M105.561 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M109.348 109.848h-3.787v3.788h3.787v-3.788Z" />
      <path d="M116.924 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 109.848h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 113.636H-.5v3.788h3.788v-3.788Z" />
      <path d="M10.864 113.636H7.076v3.788h3.788v-3.788Z" />
      <path d="M14.652 113.636h-3.788v3.788h3.787v-3.788Z" />
      <path d="M18.44 113.636H14.65v3.788h3.788v-3.788Z" />
      <path d="M26.015 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M37.379 113.636H33.59v3.788h3.788v-3.788Z" />
      <path d="M41.167 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M44.955 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M60.106 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M67.682 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M71.47 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M75.258 113.636H71.47v3.788h3.788v-3.788Z" />
      <path d="M82.833 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M86.621 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 113.636H86.62v3.788h3.788v-3.788Z" />
      <path d="M97.985 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M101.773 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M113.136 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M120.712 113.636h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 117.424H-.5v3.788h3.788v-3.788Z" />
      <path d="M26.015 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M33.59 117.424h-3.787v3.788h3.788v-3.788Z" />
      <path d="M44.955 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M52.53 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M56.318 117.424H52.53v3.788h3.788v-3.788Z" />
      <path d="M75.258 117.424H71.47v3.788h3.788v-3.788Z" />
      <path d="M79.045 117.424h-3.787v3.788h3.787v-3.788Z" />
      <path d="M86.621 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M90.41 117.424H86.62v3.788h3.788v-3.788Z" />
      <path d="M101.773 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M105.561 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M113.136 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M116.924 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M124.5 117.424h-3.788v3.788h3.788v-3.788Z" />
      <path d="M3.288 121.212H-.5V125h3.788v-3.788Z" />
      <path d="M7.076 121.212H3.288V125h3.788v-3.788Z" />
      <path d="M10.864 121.212H7.076V125h3.788v-3.788Z" />
      <path d="M14.652 121.212h-3.788V125h3.787v-3.788Z" />
      <path d="M18.44 121.212H14.65V125h3.788v-3.788Z" />
      <path d="M22.227 121.212H18.44V125h3.788v-3.788Z" />
      <path d="M26.015 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M33.59 121.212h-3.787V125h3.788v-3.788Z" />
      <path d="M48.742 121.212h-3.787V125h3.787v-3.788Z" />
      <path d="M52.53 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M60.106 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M63.894 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M67.682 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M71.47 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M79.045 121.212h-3.787V125h3.787v-3.788Z" />
      <path d="M90.41 121.212H86.62V125h3.788v-3.788Z" />
      <path d="M97.985 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M105.561 121.212h-3.788V125h3.788v-3.788Z" />
      <path d="M116.924 121.212h-3.788V125h3.788v-3.788Z" />
    </g>
    <defs>
      <clipPath id="common-qr-a">
        <path fill="#fff" d="M0 0h125v125H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'ga-icon-common-qr',
}
</script>
